import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import { Visibility } from '@mui/icons-material';
import { Box, Button, CardActions, CardContent, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import DashboardCard from '../../pages/policy/components/dashboard-card';

const PolicyPaymentScheduleCTA = () => {
	const navigate = useNavigate();

	const handleViewSchedule = () => {
		navigate(ROUTE_PATHS.fullPaymentSchedule);
	};

	return (
		<DashboardCard>
			<CardContent>
				<Typography variant='dashboard-card-heading' sx={{ mb: '1rem' }}>
					View Your Payment Schedule
				</Typography>
				<Typography variant='body1' sx={{ mb: '1rem' }}>
					Get a detailed view of your full policy payment schedule at any time. Stay informed about your upcoming
					payments.
				</Typography>
				<CardActions sx={{ justifyContent: 'center', p: '0' }}>
					<Button
						size='large'
						variant='outlined'
						color='primary'
						fullWidth
						startIcon={<Visibility style={{ fontSize: '2rem' }} />}
						onClick={handleViewSchedule}
						sx={{
							':hover': { backgroundColor: 'unset' },
							borderColor: 'primary.main',
							height: '44px',
						}}
					>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								width: '100%',
								fontWeight: 600,
								textTransform: 'none',
								fontSize: '1.08rem',
							}}
						>
							View Schedule
						</Box>
					</Button>
				</CardActions>
			</CardContent>
		</DashboardCard>
	);
};

export default PolicyPaymentScheduleCTA;
